export default {
  name: 'oz-button-number',

  props: {
    receivedNumber: { type: Number, default: 0 },
    disabled: { type: Boolean },
  },

  computed: {
    isDisabled () {
      return this.disabled
    },

    updateLabel () {
      if (this.receivedNumber < 1000 && this.receivedNumber > 0) {
        return `Buscar ${this.receivedNumber} imóveis`
      }

      if (this.receivedNumber >= 1000) {
        return 'Buscar mais de 1000 imóveis'
      }

      if (this.receivedNumber === 0) { return 'Buscar' }

      return 'Não há imóveis disponíveis'
    },
  },

  methods: {
    onSubmit () {
      this.$emit('updateFilters')
    },
  },
}
